document.addEventListener('DOMContentLoaded', () => {
  const templates = document.getElementById('manual-templates');
  const categoriaSelect = document.getElementById('manual-categoria');
  const productoSelect = document.getElementById('manual-producto');
  const resultDiv = document.getElementById('manual-result');

  if (!templates || !categoriaSelect) return;

  templates.querySelectorAll('[data-collection]').forEach(col => {
    if (col.querySelectorAll('[data-handle]').length === 0) return;
    const opt = document.createElement('option');
    opt.value = col.dataset.collection;
    opt.textContent = col.dataset.title;
    categoriaSelect.appendChild(opt);
  });

  categoriaSelect.addEventListener('change', () => {
    productoSelect.innerHTML = '<option value="">Selecciona un producto</option>';
    productoSelect.disabled = true;
    resultDiv.classList.add('hidden');
    resultDiv.innerHTML = '';

    const handle = categoriaSelect.value;
    if (!handle) return;

    const col = templates.querySelector(`[data-collection="${handle}"]`);
    if (!col) return;

    col.querySelectorAll('[data-handle]').forEach(p => {
      const opt = document.createElement('option');
      opt.value = p.dataset.handle;
      opt.dataset.image = p.dataset.image;
      opt.dataset.category = p.dataset.category;
      opt.dataset.manual = p.dataset.manual;
      opt.textContent = p.dataset.title;
      productoSelect.appendChild(opt);
    });

    productoSelect.disabled = false;
  });

  productoSelect.addEventListener('change', () => {
    resultDiv.innerHTML = '';

    if (!productoSelect.value) {
      resultDiv.classList.add('hidden');
      return;
    }

    const opt = productoSelect.options[productoSelect.selectedIndex];
    const { image, category, manual } = opt.dataset;
    const title = opt.textContent;

    let manualHref = '';
    if (manual) {
      const tmp = document.createElement('div');
      tmp.innerHTML = manual;
      const a = tmp.querySelector('a');
      manualHref = a ? a.getAttribute('href') : '';
    }

    resultDiv.innerHTML = `
      <div class="manual-product-card">
        <div class="manual-product-top">
          ${image ? `<img src="${image}" alt="${title}" class="manual-product-img">` : ''}
          <div class="manual-product-info">
            <span class="manual-product-category">${category}</span>
            <strong class="manual-product-name">${title}</strong>
          </div>
        </div>
        <div class="manual-product-actions">
          ${manualHref
            ? `<a href="${manualHref}" target="_blank" rel="noopener" class="btn-manual">Manual</a>`
            : `<span class="manual-no-disponible">Manual no disponible</span>`
          }
        </div>
      </div>
    `;
    resultDiv.classList.remove('hidden');
  });
});
